import { MapUtils } from '../../utility/map-utils.js';
import { DayOfWeek } from './day-of-week.js';
import { DataModel, DataModelBuilder, isSameData,
  isSameList, SerializationContext, SerializedData } from '../dto/dto.js';
import { TimeOfDay } from './time-of-day.js';
import { TimeSpan } from './time-span.js';

export class BusinessHoursDay extends DataModel {
  static readonly TYPE_ID: string = '256cc45db74b48b98500a6da0091aac4';

  constructor(
    public readonly dayOfWeek: DayOfWeek,
    public readonly times: TimeSpan[],
    public readonly closed: boolean = false,
  ) {
    super();
  }

  get hasAnyHoursDefined() {
    return !this.closed && this.times.length !== 0;
  }

  get $typeId() {
    return BusinessHoursDay.TYPE_ID;
  }

  static nineToFive(dayOfWeek: DayOfWeek): BusinessHoursDay {
    return new BusinessHoursDay(
        dayOfWeek,
        [new TimeSpan(new TimeOfDay(9, 0), new TimeOfDay(17, 0))],
        false,
    );
  }

  static closed(dayOfWeek: DayOfWeek): BusinessHoursDay {
    return new BusinessHoursDay(
        dayOfWeek,
        [new TimeSpan(new TimeOfDay(9, 0), new TimeOfDay(17, 0))],
        true,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): BusinessHoursDay {
    return new BusinessHoursDay(
        MapUtils.get<DayOfWeek>(map, 'dayOfWeek'),
        MapUtils.getList<TimeSpan>(map, 'times', (value) => context.fromData<TimeSpan>(value as SerializedData)),
        MapUtils.get<boolean>(map, 'closed'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'dayOfWeek': this.dayOfWeek,
      'times': this.times.map((p) => context.toData(p)),
      'closed': this.closed,
    };
  }

  clone(): this {
    return new BusinessHoursDay(
        this.dayOfWeek,
        this.times.map((e) => e.clone()),
        this.closed,
    ) as this;
  }

  isSame(other: BusinessHoursDay): boolean {
    if(other === this) {
      return true;
    }

    return other.dayOfWeek === this.dayOfWeek &&
    isSameList(other.times, this.times, isSameData) &&
    other.closed === this.closed;
  }
}

export class BusinessHoursDayBuilder extends DataModelBuilder<BusinessHoursDay> {
  build(context: SerializationContext, map: SerializedData): BusinessHoursDay {
    return BusinessHoursDay.fromMap(context, map);
  }
}
